import React from "react";
import { Container, Row, Col } from "react-bootstrap";

export default function JunkProject() {
  return (
    <Container fluid>
      <Row className="p-4">
        <Col>
          <h4>Junk Projects</h4>
          <p>No junk projects found.</p>
        </Col>
      </Row>
    </Container>
  );
}
